import React from "react";

const Notifications = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M33.222 28.79H3v-2.976h1.511V15.441C4.511 8.017 10.601 2 18.111 2s13.6 6.017 13.6 13.441v10.373h1.511v2.977zm-18.889 1.49h7.556c0 .986-.398 1.932-1.107 2.63a3.807 3.807 0 01-2.67 1.09 3.807 3.807 0 01-2.672-1.09 3.693 3.693 0 01-1.107-2.63z"
          fill={fill}
      />
    </svg>
);

export default Notifications;